import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { ROUTES } from '@/utils/constants'
import Loader from './UI/Loader'

/**
 * Protected Route wrapper that requires authentication
 * Redirects to login if user is not authenticated
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} children - Child components to render if authenticated
 * @param {Array} requiredRoles - Optional array of required roles
 */
const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const location = useLocation()
  const { isAuthenticated, isLoading, user, hasRole } = useAuth()

  // Show loader while checking authentication (with timeout to prevent infinite loading)
  if (isLoading) {
    return <Loader fullScreen text="Vérification..." />
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  // Check role requirements
  if (requiredRoles.length > 0) {
    const hasRequiredRole = requiredRoles.some(role => hasRole(role))
    
    if (!hasRequiredRole) {
      return (
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-error-500 mb-4">403</h1>
            <p className="text-gray-600 mb-4">Accès refusé</p>
            <p className="text-sm text-gray-500">
              Vous n'avez pas les permissions nécessaires pour accéder à cette page.
            </p>
          </div>
        </div>
      )
    }
  }

  return children
}

export default ProtectedRoute


